module.exports = "/packs/images/svg/ireland/facilities/personal_trainer~3797d0f36a6609717f5a529e1fabd35e.svg";